import PropTypes from 'prop-types';
import RegistrationSuccess from 'components/UI/RegistrationSuccess';
import UserKLU from 'routes/Home/components/UserKLU';
import ContractsAndSections from 'routes/Home/components/ContractsAndSections';
import UserLoyaltyPoints from 'routes/Home/components/UserLoyaltyPoints';
import AppShell from 'components/Layout/AppShell';

/**
 * Feature blocks: componentes de app embebidos como bloques CMS.
 * Cada uno se envuelve en <AppShell> con la variante apropiada para que
 * el ancho en tablet/desktop quede acotado correctamente.
 * NO se modifica la lógica interna de los componentes.
 */

export const ContractsBlock = () => (
  <section className='cms-block cms-block--contracts py-6 md:py-6 lg:py-8'>
    <AppShell variant='wide'>
      <ContractsAndSections />
    </AppShell>
  </section>
);

export const KluBlock = ({ value, isPreview }) => (
  <section className='cms-block cms-block--klu py-6 md:py-6 lg:py-8'>
    <AppShell variant='default'>
      <UserKLU {...value} isPreview={isPreview} />
    </AppShell>
  </section>
);

KluBlock.propTypes = {
  value: PropTypes.object,
  isPreview: PropTypes.bool,
};
KluBlock.defaultProps = { value: {}, isPreview: false };

export const LoyaltyPointsBlock = ({ isPreview }) => (
  <section className='cms-block cms-block--loyalty-points py-6 md:py-6 lg:py-8'>
    <AppShell variant='default'>
      <UserLoyaltyPoints isPreview={isPreview} />
    </AppShell>
  </section>
);

LoyaltyPointsBlock.propTypes = { isPreview: PropTypes.bool };
LoyaltyPointsBlock.defaultProps = { isPreview: false };

export const RegistrationSuccessBlock = ({ value, blockProps }) => (
  <section className='cms-block cms-block--registration-success py-6 md:py-6 lg:py-8'>
    <AppShell variant='narrow'>
      <RegistrationSuccess
        content={value?.content || ''}
        actions={value?.actions || []}
        btnContinueText={value?.btnContinueText || ''}
        btnContinueType={value?.btnContinueType || ''}
        btnExitText={value?.btnExitText || ''}
        btnExitType={value?.btnExitType || ''}
        {...(blockProps || {})}
      />
    </AppShell>
  </section>
);

RegistrationSuccessBlock.propTypes = {
  value: PropTypes.object,
  blockProps: PropTypes.object,
};
RegistrationSuccessBlock.defaultProps = { value: {}, blockProps: {} };
